/**
 * create by lzy 2020-01-16
 * 处理图片、视频放到编辑器中
 */
'use strict';
angular.module('processingMaterialServiceModule', []).factory('processingMaterialService', [
    '$q',
    '$timeout',
    'localStorageService',
    'mrApiService',
    'materialConst',
    'previewService',
    function($q, $timeout, localStorageService, mrApiService, materialConst, previewService) {
        var htmlContent = '';

        /**
         * [editPicture description]处理图片
         *
         * @param   {[type]}  pic  [pic description]图片对象
         *
         * @return  {[type]}       [return description]
         */
        function editPicture(pic) {
            var template =
                '<p>\n' +
                '<img class="app_image" imageSource="' +
                pic.from +
                '" meiziid="' +
                pic.resourceid +
                '" relationid="' +
                pic.relationid +
                '" src="">\n' +
                '</p>\n' +
                '<p class="imagenote" type="imagenote" imageKey="' +
                pic.resourceid +
                '">\n' +
                '</p>';

            var dom = document.createElement('div');
            dom.innerHTML = template;
            if (pic.realSrc) {
                var fileInfo = pic;
                fileInfo.tuShuo = fileInfo.tuShuo === undefined ? '' : fileInfo.tuShuo;
                var uploadpic = fileInfo.realSrc.split('=')[1];
                $(dom)
                    .find('img')
                    .attr('src', fileInfo.realSrc);
                $(dom)
                    .find('img')
                    .attr('uploadpic', uploadpic);
                $(dom)
                    .find('img')
                    .css({
                        display: 'block',
                        clear: 'both',
                        // maxWidth: 1200,
                        margin: '0 auto',
                    });
                $(dom)
                    .find('.imagenote')
                    .css({
                        marginTop: 1,
                        paddingTop: 1,
                        fontSize: 14,
                        height: 'auto',
                        color: '#8a939e',
                        paddingBottom: 6,
                        textAlign: 'left',
                        boxSizing: 'initial',
                        lineHeight: '1.5em',
                    });
                if (fileInfo.tuShuo === '') {
                    $(dom)
                        .find('.imagenote')
                        .html('请输入图片描述');
                } else {
                    $(dom)
                        .find('.imagenote')
                        .html(fileInfo.tuShuo.replace(/\n/g, '<br/>').replace(/ /g, '　'));
                }
            }
            htmlContent += $(dom).html();
        }

        /**
         * [editVideoOrAudio description]处理视频或音频
         * @param   {[type]}  videoOrAudio  [pic description]视频或音频对象
         * @return  {[type]}       [return description]
         */
        function editVideoOrAudio(videoOrAudio) {
            let src = videoOrAudio.realSrc || videoOrAudio.thumbImg;
            var template =
                '<p style="text-align: center;">\n' +
                '<img class="trsresize" type="' +
                videoOrAudio.from +
                // '" videoid="' +
                // videoOrAudio.videoId +
                '" meiziid="' +
                videoOrAudio.resourceid +
                '" relationid="' +
                videoOrAudio.relationid +
                '" src="' + src +
                '" _src="' + src + '"> \n' +
                '</p>\n' +
                '<p><br></p>';
            var dom = document.createElement('div');
            dom.innerHTML = template;
            if (videoOrAudio.videoId) {
                var fileInfo = videoOrAudio;
                $(dom).find('img').attr('src', fileInfo.thumbImg);
                $(dom).find('img').css({
                    'maxWidth': '550px',
                    // 'height': '225px',
                    'cursor': 'pointer',
                });
                if (fileInfo.resourceType === 1 || fileInfo.resourceType === '1' || fileInfo.resourceType === 'audio') {
                    // 音频使用audioid
                    $(dom).find('img').attr('videoid', fileInfo.videoId).attr('resourcetype', 'audio');
                    $(dom).find('img').css('width', '400px');
                    $(dom).find('img').css('height', '225px');
                } else {
                    // 视频使用videoid
                    $(dom).find('img').attr('videoid', fileInfo.videoId).attr('resourcetype', 'video');
                }
            }
            htmlContent += $(dom).html();
            previewService.drawVideoMark(true);
        }

        return {
            deterMinemateriaType: function() {
                var materialInfo = localStorageService.get('resourceCenterMaterialInfo');
                if (materialInfo) {
                    materialInfo = JSON.parse(materialInfo);
                    localStorageService.remove('resourceCenterMaterialInfo');
                } else {
                    return '';
                }
                if (materialInfo[0].resourcetype === 0) {
                    return this.editPicture(materialInfo);
                } else if (materialInfo[0].resourcetype <= 2) {
                    return this.editVideoOrAudio(materialInfo);
                }
                return '';
            },
            editPicture: function(imgList) {
                htmlContent = '';
                for (var j = 0; j < imgList.length; j++) {
                    // 整理图片数据，进行标签字符串组合
                    editPicture({
                        previewSrc: imgList[j].previewurl,
                        realSrc: imgList[j].previewurl || imgList[j].resourceurl,
                        size: imgList[j].resourcesize * 1024,
                        progress: '100%',
                        isPersonalPic: true,
                        from: imgList[j].mrtype,
                        resourceid: imgList[j].resourceid,
                        relationid: imgList[j].relationid,
                    });
                }
                return htmlContent;
            },
            editVideoOrAudio: function(videoOrAudioList) {
                htmlContent = '';
                if (!videoOrAudioList) {
                    return htmlContent;
                }
                for (var j = 0; j < videoOrAudioList.length; j++) {
                    var defaultImg = (!videoOrAudioList[j].resourcetype || materialConst.materialTypeDictionary[videoOrAudioList[j].resourcetype] === '视频') ? './images/video_default.png' : './images/playVideo.jpg';
                    editVideoOrAudio({
                        thumbImg: videoOrAudioList[j].thumbimg || videoOrAudioList[j].videoUrl || defaultImg, // thumbimg 是上传或选择的，videoUrl是从创作轴拖动来的
                        realSrc: videoOrAudioList[j].resourceurl,
                        from: videoOrAudioList[j].mrtype,
                        videoId: videoOrAudioList[j].videoid || videoOrAudioList[j].VIDEOID,
                        resourceType: videoOrAudioList[j].resourcetype,
                        resourceid: videoOrAudioList[j].resourceid,
                        relationid: videoOrAudioList[j].relationid,
                        resourcestatus: videoOrAudioList[j].resourcestatus,
                    });
                }
                return htmlContent;
            },

            /**
             * [transcodeVideo description] 转码中的视频是否转码完成，若转码完成替换封面图
             *
             * @param   {[type]}  list  [list description] list数据
             *
             * @return  {function}      [return description]
             */
            transcodeVideo: function(list) {
                var defer = $q.defer();
                var domBox = document.createElement('div');
                $(domBox).html(list.HTMLCONTENT);
                var dom = $(domBox).find('img[src="./images/video_default.png"]');
                var domArr = Array.prototype.slice.call(dom);
                var videoIdArr = domArr.filter(function(item){
                    return !!($(item).attr('relationid'));
                }).map(function(item) {
                    return $(item).attr('relationid');
                });
                if (videoIdArr.length) {
                    var params = {
                        mrType: 'personal',
                        mainResourceType: 2,
                        relationIds: videoIdArr.join(','),
                    };
                    mrApiService.takeDoc(params).then(function(data) {
                        for (var i = 0; i < data.datas.length; i++) {
                            var index = videoIdArr.indexOf(data.datas[i].relationid);
                            if (data.datas[i].previewurl && data.datas[i].thumbimg) {
                                $(dom[index]).attr('src', data.datas[i].thumbimg);
                            }
                        }
                        defer.resolve($(domBox).html());
                    }, function() {
                        defer.resolve();
                    });
                } else {
                    defer.resolve();
                }
                return defer.promise;
            },
        };
    },
]);
